<template>
    <div>
        <table class="table bg-white" :class="imprimindo ? 'table-sm' : ''">
            <thead>
                <tr>
                    <th>Procedimento</th>
                    <th v-if="imprimindo">{{ tem_prazo ? 'Prazo' : '' }}</th>
                    <th>Código</th>
                    <th class="text-right">Qtde</th>
                    <th></th>
                    <th class="text-right">Valor</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(item, idx) in procedimentos">
                    <tr :key="idx">
                        <td>
                            <a href="#" @click.prevent="remover(idx)" class="text-danger d-print-none mr-2" v-if="pode_alterar_orcamento">
                                <i class="fas fa-minus fa-fw"></i>
                            </a>
                            {{ item.procedimento.st_procedimento ? item.procedimento.st_procedimento : item.procedimento.search }}
                            <span v-if="item.procedimento.id_classe_procedimento == 1" class="text-muted">
                                {{ item.procedimento.especialidade.st_especialidade }}
                            </span>
                            <span v-if="item.procedimento.id_classe_procedimento == 1 && item.tipo_consulta" class="badge badge-warning badge-pill ml-2 mr-1" title="Tipo de Consulta">
                                {{ item.tipo_consulta }}
                            </span>

                            <a href="#" @click.prevent="editar_consumo(idx)" class="card-link d-print-none" v-if="pode_alterar_orcamento">
                                <i class="fas fa-cart-plus"></i>
                            </a>
                            <div v-if="item.medico" class="small text-muted ml-5">
                                {{ item.medico.st_nome_exibicao }}
                            </div>
                            <div v-if="item.procedimento.in_prazo_entrega && !imprimindo" class="small text-muted ml-5">
                                Prazo: 
                                <span>{{ item.procedimento.in_prazo_entrega }}</span>
                                <span class="ml-1">{{ traduzir_tempo(item.procedimento.in_prazo_entrega, item.procedimento.st_tempo_prazo_entrega) }}</span>
                            </div>
                        </td>
                        <td v-if="imprimindo">
                            <div v-if="item.procedimento.in_prazo_entrega" class="small text-muted">
                                <span>{{ item.procedimento.in_prazo_entrega }}</span>
                                <span class="ml-1">{{ traduzir_tempo(item.procedimento.in_prazo_entrega, item.procedimento.st_tempo_prazo_entrega) }}</span>
                            </div>
                        </td>
                        <td>
                            <span v-if="item.item_tabela">
                                {{ item.item_tabela.st_codigo }}
                            </span>
                        </td>
                        <td class="text-right" style="width: 150px;">
                            <span v-if="imprimindo">
                                {{ item.in_quantidade }}
                            </span>
                            <az-input
                                v-else
                                sizing="sm"
                                :edicao="false" 
                                type="number" 
                                v-model="item.in_quantidade">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append" v-if="pode_alterar_orcamento && !item.atendimento_pacote">
                                        <button class="btn btn-outline-danger" type="button" @click="alterar_qtde(item, false)"
                                            v-if="item.in_quantidade > 1">
                                            <i class="fa fa-minus-circle" aria-hidden="true"></i>
                                        </button>
                                        <button class="btn btn-outline-success" type="button" @click="alterar_qtde(item, true)">
                                            <i class="fa fa-plus-circle" aria-hidden="true"></i>
                                        </button>
                                        <button type="button" class="btn btn-outline-primary" v-if="item.procedimento && item.procedimento.procedimento_pacotes && item.procedimento.procedimento_pacotes.length"
                                            @click="ver_pacotes(item.procedimento.procedimento_pacotes, idx)">
                                            <i class="fas fa-layer-group"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </td>
                        <td class="text-right" style="width: 150px;" v-if="!imprimindo && item.ed && !item.atendimento_pacote">
                            <az-input
                                v-if="pode_ver_valor"
                                :key="'V' + idx"
                                sizing="sm"
                                :type="removendo ? 'number' : 'money'"
                                v-model="item.dc_valor_procedimento" />
                        </td>
                        <td v-else></td>
                        <td class="text-right">
                            <span :class="nao_exibir_valor_do_item ? 'd-print-none' : ''" v-if="pode_ver_valor && !item.atendimento_pacote">
                                {{ $util.formatMoeda(item.dc_valor_procedimento * item.in_quantidade) }}
                            </span>
                        </td>
                    </tr>
                    <tr :key="'PS' + idx" v-if="item.atendimento_pacote">
                        <td>
                            <i class="fas fa-layer-group fa-fw mr-3 d-print-none"></i>
                            <a href="#" @click.prevent="retirar_pacote(item)" class="text-danger d-print-none mr-2" v-if="pode_alterar_orcamento">
                                <i class="fas fa-minus fa-fw"></i>
                            </a>
                            {{ item.atendimento_pacote.search }}
                            
                            <pre v-if="false">{{ item.atendimento_pacote }}</pre>
                        </td>
                        <td v-if="imprimindo"></td>
                        <td></td>
                        <td class="text-right">x{{ item.atendimento_pacote.in_quantidade_items }}</td>
                        <td class="text-right" style="width: 150px;" v-if="!imprimindo && item.ed">
                            <az-input
                                v-if="pode_ver_valor"
                                sizing="sm"
                                type="money"
                                v-model="item.atendimento_pacote.dc_valor_pacote" />
                        </td>
                        <td class="text-right">{{ $util.formatMoeda(item.atendimento_pacote.dc_valor_pacote) }}</td>
                    </tr>
                    <tr :key="'PC' + idx" v-else-if="indexProcPacote == idx">
                        <td colspan="5">
                            <div class="list-group">
                                <button type="button" class="list-group-item list-group-item-action"
                                    v-for="(pacote, index) in pacotes" :key="index" @click="selecionar_pacote(pacote)">
                                    <i class="fas fa-layer-group mr-2 text-primary"></i>
                                    {{ pacote.search }}
                                </button>
                            </div>
                        </td>
                        <td v-if="imprimindo"></td>
                    </tr>
                    <template v-if="!nao_exibir_valor_do_item">
                        <template v-for="(comp, icx) in item.comparacao">
                            <tr :key="'C' + idx + '.' + icx">
                                <td colspan="3">
                                    <small class="text-muted ml-3">{{ comp.plano.search }}</small>
                                </td>
                                <td v-if="imprimindo"></td>
                                <td class="text-right">
                                    <small v-if="pode_ver_valor" class="text-muted">{{ $util.formatMoeda(comp.valor.valor * item.in_quantidade) }}</small>
                                </td>
                            </tr>
                        </template>
                    </template>
                    <tr v-for="(consumo, icx) in item.atendimento_procedimento_consumos" :key="idx + '.' + icx" :class="exibir_mat_med_tx ? '' : 'd-print-none'">
                        <td colspan="2">
                            <i class="fas fa-shopping-cart mr-3 d-print-none"></i>
                            <a href="#" @click.prevent="remover_consumo(item, icx)" class="text-danger mr-2" v-if="pode_alterar_orcamento">
                                <i class="fas fa-minus"></i>
                            </a>
                            {{ consumo.search }}
                        </td>
                        <td v-if="imprimindo"></td>
                        <td class="text-right" style="width: 150px;">
                            <span v-if="imprimindo">
                                {{ consumo.in_quantidade }}
                            </span>
                            <az-input
                                v-else
                                sizing="sm"
                                :edicao="pode_alterar_orcamento" 
                                type="number" 
                                v-model="consumo.in_quantidade">
                                <template v-slot:buttonposb v-if="false && pode_alterar_orcamento">
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-primary" type="button" @click="editar_qtde(consumo)">
                                            <i class="fas fa-edit fa-fw"></i>
                                        </button>
                                        <button class="btn btn-outline-danger" type="button" @click="alterar_qtde_consumo(consumo, false)"
                                            v-if="consumo.in_quantidade > 1">
                                            <i class="fa fa-minus-circle fa-fw" aria-hidden="true"></i>
                                        </button>
                                        <button class="btn btn-outline-success" type="button" @click="alterar_qtde_consumo(consumo, true)">
                                            <i class="fa fa-plus-circle fa-fw" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </td>

                        <!-- Edição do Valor -->
                        <td class="text-right" style="width: 150px;" v-if="!imprimindo && item.ed && !item.atendimento_pacote">
                            <az-input
                                v-if="pode_ver_valor"
                                :key="'VC-' + idx"
                                sizing="sm"
                                :type="removendo ? 'number' : 'money'"
                                v-model="consumo.dc_valor_unitario" />
                        </td>
                        <td v-else></td>
                        <!-- Fim Edição Valor -->

                        <td class="text-right">
                            <span :class="nao_exibir_valor_do_item ? 'd-print-none' : ''" v-if="pode_ver_valor">
                                {{ $util.formatMoeda(consumo.dc_valor_unitario * consumo.in_quantidade) }}
                            </span>
                        </td>
                    </tr>
                    <tr :key="idx + 'mmt'" v-if="imprimindo && !exibir_mat_med_tx && item.atendimento_procedimento_consumos.length">
                        <td colspan="2">
                            <i class="fas fa-shopping-cart mr-3"></i>
                            <a href="#" class="text-danger mr-2">
                                <i class="fas fa-minus"></i>
                            </a>
                            Materiais/Medicamentos/Taxas
                        </td>
                        <td class="text-right" style="width: 150px;">
                            ...
                        </td>
                        <td v-if="imprimindo"></td>
                        <td></td>
                        <td class="text-right">
                            {{ $util.formatMoeda(item.atendimento_procedimento_consumos.reduce((total, carry) => { 
                                return total + ( carry.dc_valor_unitario * carry.in_quantidade );
                            }, 0)) }}
                        </td>
                    </tr>
                    <tr :key="'NC'+ idx" v-if="linha_incluir_consumo === idx" class="d-print-none">
                        <td colspan="4">
                            <az-input 
                                class="ml-3 mb-3"
                                sizing="sm"
                                icon="fas fa-cart-plus fa-fw"
                                buttonToolTip="Incluir material, medicamento ou taxa."
                                type="autocomplete" 
                                optionsMode="aql"
                                optionsName="consumo.index" 
                                service="consumo.index"
                                :optionsParm="{ id_operadora: dados.plano.operadora.id_operadora }"
                                :optionsSync="true"
                                placeholder="Incluir material, medicamento ou taxa." 
                                v-model="novoComponente"
                                @input="incluirComponente (item)" />
                        </td>
                        <td v-if="imprimindo"></td>
                    </tr>
                </template>
            </tbody>
            <tfoot v-if="procedimentos && procedimentos.length && pode_ver_valor">
                <tr>
                    <th colspan="4">
                        Total
                        <span class="badge badge-secondary ml-2">
                            {{ procedimentos.length }}
                        </span>
                    </th>
                    <th v-if="imprimindo"></th>
                    <th class="text-right">{{ $util.formatMoeda(total_orcado) }}</th>
                </tr>
                <template v-if="desconto > 0">
                    <tr>
                        <th colspan="2">
                            Desconto
                        </th>
                        <th v-if="imprimindo"></th>
                        <th>
                            <span v-if="tipo_desconto == 'P'">
                                {{ $util.formatMoeda(desconto) }}%
                            </span>
                        </th>
                        <th></th>
                        <th class="text-right">
                            {{ $util.formatMoeda(valor_desconto) }}
                        </th>
                    </tr>
                    <tr>
                        <th colspan="4">
                            Valor Final
                        </th>
                        <th v-if="imprimindo"></th>
                        <th class="text-right">{{ $util.formatMoeda(total_orcado - valor_desconto) }}</th>
                    </tr>
                </template>
            </tfoot>
        </table>
    </div>
</template>

<script>
import AzInput from '../../shared/forms/AzInput.vue'

export default {
    data() { 
        return { 
            indexProcPacote: null, 
            linha_incluir_consumo: null, 
            removendo: false, 
        }
    },

    components: { 
        AzInput, 
    },

    props: ['imprimindo', 'procedimentos', 'pode_alterar_orcamento', 'pode_ver_valor', 'desconto', 'nao_exibir_valor_do_item', 'exibir_mat_med_tx'], 

    computed: { 
        is_lab: function () { 
            if ( !this.procedimentos )
                return false;

            return this.procedimentos.find(item => item.procedimento && item.procedimento.id_especialidade == 2) ? true : false;
        },

        is_vacina: function () { 
            if ( !this.procedimentos )
                return false;

            return this.procedimentos.find(item => item.procedimento && item.procedimento.id_classe_procedimento == 19) ? true : false;
        },

        orcamento_convertido: function () { 
            return ( this.orcamento && this.orcamento.id_orcamento == this.id_orcamento && this.orcamento.marcacoes && this.orcamento.marcacoes.length )
                ? true 
                : false;
        },

        valor_desconto: function () { 
            if ( this.tipo_desconto == 'V' )
                return this.desconto;

            return ( this.desconto > 0 ) ? Math.round ( this.total_orcado * this.desconto ) / 100 : 0;
        },

        total_orcado: function () { 
            return this.procedimentos.reduce((total, carry) => { 
                return total 
                    + ( carry.atendimento_pacote ? carry.atendimento_pacote.dc_valor_pacote : ( carry.dc_valor_procedimento * carry.in_quantidade) )
                    + carry.atendimento_procedimento_consumos.reduce((totalc, carryc) => { 
                        return totalc + (carryc.dc_valor_unitario * carryc.in_quantidade)
                    }, 0); 
            }, 0);
        },
    },

    methods: { 
        traduzir_tempo(num, tempo) { 
            switch (tempo) {
                case 'days': return num > 1 ? 'dias úteis' : 'dia util';
                case 'hours': return num > 1 ? 'horas' : 'hora';
            }

            return tempo;
        },
    }
}
</script>
